import { createSlice, current } from "@reduxjs/toolkit";

const defaultData = {
  dataUser: {},
  currentPage: null,
  prevPage: null,
};

export const RegisterSlice = createSlice({
  name: "Register",
  initialState: defaultData,
  reducers: {
    setRegister: (state, action) => {
      for (const [key, value] of Object.entries(action.payload)) {
        state[key] = value;
      }
    },
    resetRegister: () => defaultData,
  },
});

// Action creators are generated for each case reducer function
export const { setRegister, resetRegister } = RegisterSlice.actions;

export default RegisterSlice.reducer;
